module.exports = __webpack_public_path__ + "static/media/Breakdancer.5b2ea684.jpg";